/**
 * Maps job type values to their display labels.
 * @param {Array} content - Array of items with jobType field
 * @param {Array} jobTypeOptions - Options with {value, label} pairs
 * @returns {Array} Content with jobType values replaced by labels
 */
export function mapJobTypeToLabel(content, jobTypeOptions) {
  if (!Array.isArray(content)) return [];
  return content.map((item) => {
    const match = jobTypeOptions.find((opt) => opt.value === item.jobType);
    return {
      ...item,
      jobType: match ? match.label : item.jobType,
    };
  });
}
